import Client from "./client";
import Spark from "./spark";

export default class Sandbox {
    constructor() {
        this.client = new Client()
    }

    spark() {
        return new Spark(this.client)
    }
}